import { IS_DEV_ENV } from "./isDevEnv";

export type AWSCredentials = {
  accessKeyId: string;
  secretAccessKey: string;
  sessionToken: string;
};

export const AWS_REGION = "us-east-1";

// TODO: instead of hard-coded, these values should be put in the environment
export const AUDIO_UPLOAD_BUCKET_DEV = "pro-uploaded-audio-dev2";
export const AUDIO_UPLOAD_BUCKET_PROD = "pro-uploaded-audio-prod2";

export const AUDIO_RECORDING_S3_BUCKET = IS_DEV_ENV
  ? AUDIO_UPLOAD_BUCKET_DEV
  : AUDIO_UPLOAD_BUCKET_PROD;

export const CHAT_HISTORY_S3_BUCKET = IS_DEV_ENV
  ? "orchid-chat-history-dev"
  : "orchid-chat-history-prod";